
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/alsps/[slug]",
      function () {
        return require("private-next-pages/alsps/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/alsps/[slug]"])
      });
    }
  